<template>
  <div class="home">
    <!-- 按钮集合 -->
    <section class="buttons">
      <div>
        <Button @click="reloads" icon="md-refresh" size="small" type="warning">重置</Button>
        <Button @click="realTimeView.show = true" icon="md-easel" size="small" type="primary">预览</Button>
        <Button
          @click="$refs.file.click()"
          icon="md-cloud-upload"
          size="small"
          type="primary"
        >导入JSON</Button>
        <input
          @change="importJSON"
          accept=".json"
          id="file"
          ref="file"
          style="display: none"
          type="file"
        />
        <Button @click="exportJSON" icon="md-cloud-download" size="small" type="primary">导出JSON</Button>
        <Button @click="Preservation" size="small" type="error">
          <i class="fa fa-save" style="margin-right:4px" />&nbsp;保存
        </Button>
      </div>
    </section>

    <!-- 装修操作 -->
    <section class="operation">
      <!-- 组件 -->
      <div class="sliderConatiner">
        <GeminiScrollbar :autoshow="true" :style="{width: '100%'}" class="my-scroll-bar fullMenu">
          <!-- <component :is='allHandleComps["sliderassembly"]' :pointer="pointer"></component> -->
          <div class="sliderassembly">
            <Collapse v-model="activeNames">
              <Panel :key="items.key" :name="items.key" v-for="(items, index) in datas">
                {{items.title}}
                <template #content>
                  <div
                    :data-name="item.name"
                    :key="ind"
                    @drag="drag"
                    @dragend="dragend"
                    @dragstart="drag($event)"
                    class="componList"
                    draggable="true"
                    unselectable="on"
                    v-for="(item, ind) in items.comList"
                  >
                    <i :class="'iconfont ' + item.icon" class="iconfont" v-if="item.icon" />
                    <p>{{ item.text }}</p>
                  </div>
                </template>
              </Panel>
            </Collapse>
          </div>
        </GeminiScrollbar>
      </div>

      <div :class="'panel ' + (toolBarClose?'full': 'part')" ref="panelContainer">
        <section class="panelAll" id="imageTofile" ref="imageTofile">
          <!-- 主体内容 -->
          <div class="panel-container-p">
            <GeminiScrollbar
              :autoshow="true"
              :style="{width: '100%', height: '100%'}"
              class="my-scroll-bar"
            >
              <section
                :style="{'transform': scale, 'transform-origin': '1rem 1rem', 'background-color': pageSetup.bgColor, backgroundImage: pageSetup.bgImg?'url(' + this.$store.getters['systemSupport/systemSupport']?.file + pageSetup.bgImg + ')':'', }"
                @dragleave="dragleaves($event)"
                @dragover="allowDrop($event)"
                @drop="drop($event)"
                class="panel-container"
                id="componentContent"
              >
                <grid-layout
                  :col-num="12"
                  :is-draggable="true"
                  :is-mirrored="false"
                  :is-resizable="true"
                  :layout.sync="pageComponents"
                  :margin="[10, 10]"
                  :row-height="30"
                  :use-css-transforms="true"
                  :vertical-compact="true"
                  ref="gridlayout"
                >
                  <grid-item
                    :h="item.h"
                    :i="item.i"
                    :key="item.i"
                    :w="item.w"
                    :x="item.x"
                    :y="item.y"
                    v-for="item in pageComponents"
                  >
                    <!-- <div :class="pointer.show ? 'pointer-events' : ''"> -->
                    <!-- 动态组件 -->
                    <!-- <component :is="allHandleComps[item.component]" :key="item.component" :datas="item.setStyle" :style="{border: item.active && deleShow ? '2px solid #155bd4' : ''}"
                                        @click.native="activeComponent(item, index)" class="componentsClass" :data-type="item.type">
                    </component>-->
                    <!-- </div> -->
                  </grid-item>
                </grid-layout>
              </section>
            </GeminiScrollbar>
          </div>
          <!-- 比例 -->
          <section class="toolsContianer">
            <div>
              <InputNumber
                :formatter="value => `${value}%`"
                :max="200"
                :min="25"
                :parser="value => value.replace('%', '')"
                :step="25"
                controls-outside
                v-model="scalePercent"
              ></InputNumber>
            </div>
            <div class="panelSize">原始尺寸：1920 * 1080</div>
          </section>
        </section>
      </div>

      <!-- 右侧工具栏 -->
      <div :class="'decorateAll ' + (toolBarClose?'close': 'open')">
        <!-- 页面设置tab -->
        <Tabs v-model="rightcom">
          <TabPane icon="ios-images" label="页面设置" name="decorate"></TabPane>
          <TabPane icon="logo-buffer" label="组件管理" name="componenmanagement"></TabPane>
          <TabPane
            :name="rightcom"
            icon="md-construct"
            label="组件设置"
            v-if="rightcom != 'componenmanagement' && rightcom != 'decorate'"
          ></TabPane>
        </Tabs>
        <div class="decoratePanel">
          <GeminiScrollbar :autoshow="true" :style="{width: '100%'}" class="my-scroll-bar">
            <!-- 动态组件 -->
            <component
              :datas="currentproperties"
              :is="allHandleComps[rightcom]"
              @componenmanagement="componenmanagement"
            />
          </GeminiScrollbar>
        </div>
        <div
          @click="toolBarHandler"
          class="toolBar"
        ><i :class="toolBarClose?"fa fa-angle-double-right":"fa fa-angle-double-left"" /></div>
      </div>
    </section>
    <component
    :datas="realTimeView"
    :is="allHandleComps["realTimeView"]"
    :val="{id, name: pageSetup.name, templateJson: JSON.stringify(pageSetup), component: JSON.stringify(pageComponents)}"
    v-if="realTimeView.show"
    />
  </div>
</template>

<script>
import VueGridLayout from 'vue-grid-layout'
import utils from './pageConfig-Comp/utils/index' // 方法类
import componentProperties from './pageConfig-Comp/utils/componentProperties' // 组件数据
import html2canvas from 'html2canvas' // 生成图片
import FileSaver from 'file-saver' // 导出JSON
//加载子组件
// import resultComps from './tools/index.js'

const GridLayout = VueGridLayout.GridLayout
const GridItem = VueGridLayout.GridItem


let mouseXY = { "x": null, "y": null }
let DragPos = { "x": null, "y": null, "w": 1, "h": 1, "i": null }
export default {
  name: 'home',
  inject: ['reload'],
  components: {
    GridLayout, GridItem
  },
  data () {
    return {
      activeNames: [],
      datas: [
        {
          title: '基础组件',
          key: 'base',
          comList: [
            {
              text: '商品搜索',
              type: '1-1',
              icon: 'icon-shangpinsousuo',
              name: 'commoditysearch',
            },
            {
              text: '标题文本',
              type: '1-3',
              icon: 'icon-Component-biaotiwenzi',
              name: 'captiontext',
            },

            {
              text: '图片广告',
              type: '1-3',
              icon: 'icon-tupianguanggao',
              name: 'pictureads',
            },
            {
              text: '图文导航',
              type: '1-4',
              icon: 'icon-icon_tupiandaohang',
              name: 'graphicnavigation',
            },
            {
              text: '底部导航',
              type: '1-5',
              icon: 'icon-daohang',
              name: 'tabBar',
            },
            {
              text: '魔方',
              type: '1-6',
              icon: 'icon-mofang',
              name: 'magiccube',
            },
            {
              text: '公告',
              type: '1-7',
              icon: 'icon-gonggao',
              name: 'notice',
            },

            {
              text: '视频',
              type: '1-8',
              icon: 'icon-shipin',
              name: 'videoss',
            },
            {
              text: '富文本',
              type: '1-10',
              icon: 'icon-fuwenben',
              name: 'richtext',
            },
            {
              text: '辅助分割',
              type: '1-11',
              icon: 'icon-Component-fuzhufenge',
              name: 'auxiliarysegmentation',
            },

            {
              text: '店铺信息',
              type: '1-12',
              icon: 'icon-dianpuxinxi',
              name: 'storeinformation',
            },
            {
              text: '单元格',
              type: '1-13',
              icon: 'icon-jinrudianpu',
              name: 'entertheshop',
            },
            {
              text: '社群涨粉',
              type: '1-14',
              icon: 'icon-kuaisuzhangfen',
              name: 'communitypowder',
            },
            /* {
            text: 'xxx',
            type: '1-17',
            icon: 'icon-yunying',
            name: ''
            }, */
            /* {
            text: 'xxx',
            type: '1-19',
            icon: 'icon-weibiaoti-_huaban',
            name: ''
            }, */
            /* {
            text: 'xxxx',
            type: '1-18',
            icon: 'icon-gexinghuatuijian',
            name: ''
            }, */
            {
              text: '关注公众号',
              type: '1-15',
              icon: 'icon-gongzhonghao',
              name: 'follow',
            },
            {
              text: '悬浮',
              type: '1-16',
              icon: 'icon-wangye',
              name: 'suspension',
            },
            {
              text: '自定义模块',
              type: 'demo',
              icon: 'icon-zidingyimokuai',
              name: 'custommodule'
            },
          ],
        },
        {
          title: '业务组件',
          key: 'business',
          comList: [
            {
              text: '商品',
              type: '2-1',
              icon: 'icon-goods',
              name: 'listswitching',
            },
            {
              text: '文章模块',
              type: '2-2',
              icon: 'icon-dianpubijikapian',
              name: 'storenotecard',
            },
            {
              text: '表单模块',
              type: '2-3',
              vanIcon: 'orders-o',
              name: 'investigate',
            }
          ]
        },

      ],
      layout: [
        { "x": 0, "y": 0, "w": 2, "h": 2, "i": "0" },
        { "x": 2, "y": 0, "w": 2, "h": 4, "i": "1" },
        { "x": 4, "y": 0, "w": 2, "h": 5, "i": "2" },
        { "x": 6, "y": 0, "w": 2, "h": 3, "i": "3" },
        { "x": 8, "y": 0, "w": 2, "h": 3, "i": "4" },
        { "x": 10, "y": 0, "w": 2, "h": 3, "i": "5" },
        { "x": 0, "y": 5, "w": 2, "h": 5, "i": "6" },
        { "x": 2, "y": 5, "w": 2, "h": 5, "i": "7" },
        { "x": 4, "y": 5, "w": 2, "h": 5, "i": "8" },
        { "x": 6, "y": 3, "w": 2, "h": 4, "i": "9" },
        { "x": 8, "y": 4, "w": 2, "h": 4, "i": "10" },
        { "x": 10, "y": 4, "w": 2, "h": 4, "i": "11" },
        { "x": 0, "y": 10, "w": 2, "h": 5, "i": "12" },
        { "x": 2, "y": 10, "w": 2, "h": 5, "i": "13" },
        { "x": 4, "y": 8, "w": 2, "h": 4, "i": "14" },
        { "x": 6, "y": 8, "w": 2, "h": 4, "i": "15" },
        { "x": 8, "y": 10, "w": 2, "h": 5, "i": "16" },
        { "x": 10, "y": 4, "w": 2, "h": 2, "i": "17" },
        { "x": 0, "y": 9, "w": 2, "h": 3, "i": "18" },
        { "x": 2, "y": 6, "w": 2, "h": 2, "i": "19" }
      ],
      toolBarClose: false,
      scalePercent: 100,
      // allHandleComps: resultComps,
      realTimeView: {
        show: false, // 是否显示预览
      },
      id: null, //当前页面
      deleShow: true, //删除标签显示
      index: '', //当前选中的index
      rightcom: 'decorate', //右侧组件切换
      currentproperties: {}, //当前属性
      pageSetup: {
        // 页面设置属性
        name: '页面标题', //页面名称
        details: '', //页面描述
        isPerson: false, // 是否显示个人中心
        isBack: true, // 是否返回按钮
        titleHeight: 35, // 高度
        bgColor: 'rgba(255, 255, 255, 1)', //背景颜色
        bgImg: '', // 背景图片
      },
      pageComponents: [], //页面组件
      offsetY: 0, //记录上一次距离父元素高度
      pointer: { show: false }, //穿透
      onlyOne: ['1-5', '1-16'], // 只能存在一个的组件(组件的type)
    }
  },
  methods: {
    drag: function (event) {

      let parentRect = document.getElementById('componentContent').getBoundingClientRect()
      let mouseInGrid = false
      if (((mouseXY.x > parentRect.left) && (mouseXY.x < parentRect.right)) && ((mouseXY.y > parentRect.top) && (mouseXY.y < parentRect.bottom))) {
        mouseInGrid = true
      }
      if (mouseInGrid === true && (this.pageComponents.findIndex(item => item.i === 'drop')) === -1) {
        this.pageComponents.push({
          x: (this.pageComponents.length * 2) % (this.colNum || 12),
          y: this.pageComponents.length + (this.colNum || 12), // puts it at the bottom
          w: 1,
          h: 1,
          i: 'drop',
        })
      }
      let index = this.pageComponents.findIndex(item => item.i === 'drop')
      if (index !== -1) {
        try {
          this.$refs.gridlayout.$children[this.pageComponents.length].$refs.item.style.display = "none"
        } catch (err) {
        }
        let el = this.$refs.gridlayout.$children[index]
        el.dragging = { "top": mouseXY.y - parentRect.top, "left": mouseXY.x - parentRect.left }
        let new_pos = el.calcXY(mouseXY.y - parentRect.top, mouseXY.x - parentRect.left)
        if (mouseInGrid === true) {
          this.$refs.gridlayout.dragEvent('dragstart', 'drop', new_pos.x, new_pos.y, 1, 1)
          DragPos.i = String(index)
          DragPos.x = this.pageComponents[index].x
          DragPos.y = this.pageComponents[index].y
        }
        if (mouseInGrid === false) {
          this.$refs.gridlayout.dragEvent('dragend', 'drop', new_pos.x, new_pos.y, 1, 1)
          this.pageComponents = this.pageComponents.filter(obj => obj.i !== 'drop')
        }
      }
      // event.dataTransfer.setData('componentName', event.target.dataset.name)
    },
    dragend: function (event) {
      let parentRect = document.getElementById('componentContent').getBoundingClientRect()
      let mouseInGrid = false
      if (((mouseXY.x > parentRect.left) && (mouseXY.x < parentRect.right)) && ((mouseXY.y > parentRect.top) && (mouseXY.y < parentRect.bottom))) {
        mouseInGrid = true
      }
      if (mouseInGrid === true) {
        alert(`Dropped element props:\n${JSON.stringify(DragPos, ['x', 'y', 'w', 'h'], 2)}`)
        this.$refs.gridlayout.dragEvent('dragend', 'drop', DragPos.x, DragPos.y, 1, 1)
        this.pageComponents = this.pageComponents.filter(obj => obj.i !== 'drop')
        // UNCOMMENT below if you want to add a grid-item
        /*
        this.layout.push({
            x: DragPos.x,
            y: DragPos.y,
            w: 1,
            h: 1,
            i: DragPos.i,
        });
        this.$refs.gridLayout.dragEvent('dragend', DragPos.i, DragPos.x,DragPos.y,1,1);
        try {
            this.$refs.gridLayout.$children[this.layout.length].$refs.item.style.display="block";
        } catch {
        }
        */
      }
    },
    toolBarHandler: function () {
      this.toolBarClose = !this.toolBarClose
    },
    /**
     * 保存
     */
    Preservation () {
      /* 隐藏border和删除图标 */
      this.deleShow = false
      /* 渲染结束截图 */
      this.$nextTick(() => {
        /* 截图 */
        this.toImage()
      })
    },

    /**
     * 页面截图
     *
     * @param {Function} callBack 回调函数
     */
    toImage () {
      /* 加载 */
      const loading = this.$loading({
        lock: true,
        text: '保存中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      const imageTofiles = document.querySelector('#imageTofile')
      /* 截图 */
      html2canvas(this.$refs.imageTofile, {
        backgroundColor: null,
        height: imageTofiles.scrollHeight,
        width: imageTofiles.scrollWidth,
        useCORS: true,
      }).then((canvas) => {
        /* 显示border和删除图标 */
        this.deleShow = true
        let url = canvas.toDataURL('image/png')
        const formData = new FormData()
        formData.append('base64File', url)
        console.log(formData, '--------------页面图片formData')
        loading.close()
      })
    },

    /**
     * 当将元素或文本选择拖动到有效放置目标（每几百毫秒）上时，会触发此事件
     *
     * @param {Object} event event对象
     */
    allowDrop (event) {
      //阻止浏览器的默认事件
      event.preventDefault()

      /* 获取鼠标高度 */
      let eventoffset = event.offsetY

      /* 如果没有移动不触发事件减少损耗 */
      if (this.offsetY === eventoffset) return
      else this.offsetY = eventoffset

      /* 获取组件 */
      const childrenObject = event.target.children[0]

      // 一个以上的组件计算
      if (this.pageComponents.length) {
        /* 如果只有一个组件并且第一个是提示组件直接返回 */
        if (
          this.pageComponents.length === 1 &&
          this.pageComponents[0].type === 0
        )
          return

        /* 如果鼠标的高度小于第一个的一半直接放到第一个 */
        if (eventoffset < childrenObject.children[0].clientHeight / 2) {
          /* 如果第一个是提示组件直接返回 */
          if (this.pageComponents[0].type === 0) return

          /* 删除提示组件 */
          this.pageComponents = this.pageComponents.filter(
            (res) => res.component !== 'placementarea'
          )

          /* 最后面添加提示组件 */
          this.pageComponents.unshift({
            component: 'placementarea',
            type: 0,
          })

          return
        }

        /* 记录距离父元素高度 */
        const childOff = childrenObject.offsetTop

        /* 鼠标在所有组件下面 */
        if (
          eventoffset > childrenObject.clientHeight ||
          childrenObject.lastChild.offsetTop -
          childOff +
          childrenObject.lastChild.clientHeight / 2 <
          eventoffset
        ) {
          /* 最后一个组件是提示组件返回 */
          if (this.pageComponents[this.pageComponents.length - 1].type === 0)
            return

          /* 清除提示组件 */
          this.pageComponents = this.pageComponents.filter(
            (res) => res.component !== 'placementarea'
          )

          /* 最后一个不是提示组件添加 */
          this.pageComponents.push({
            component: 'placementarea',
            type: 0,
          })

          return
        }

        const childrens = childrenObject.children

        /* 在两个组件中间，插入 */
        for (let i = 0, l = childrens.length; i < l; i++) {
          const childoffset = childrens[i].offsetTop - childOff

          if (childoffset + childrens[i].clientHeight / 2 > event.offsetY) {
            /* 如果是提示组件直接返回 */
            if (this.pageComponents[i].type === 0) break

            if (this.pageComponents[i - 1].type === 0) break

            /* 清除提示组件 */
            this.pageComponents = this.pageComponents.filter(
              (res) => res.component !== 'placementarea'
            )

            this.pageComponents.splice(i, 0, {
              component: 'placementarea',
              type: 0,
            })
            break
          } else if (childoffset + childrens[i].clientHeight > event.offsetY) {
            if (this.pageComponents[i].type === 0) break

            if (
              !this.pageComponents[i + 1] ||
              this.pageComponents[i + 1].type === 0
            )
              break

            this.pageComponents = this.pageComponents.filter(
              (res) => res.component !== 'placementarea'
            )

            this.pageComponents.splice(i, 0, {
              component: 'placementarea',
              type: 0,
            })

            break
          }
        }
      } else {
        /* 一个组件都没有直接push */
        this.pageComponents.push({
          component: 'placementarea',
          type: 0,
        })
      }
    },

    /**
     * 当在有效放置目标上放置元素或选择文本时触发此事件
     *
     * @param {Object} event event对象
     */
    drop (event) {
      console.log('start drop')
      /* 获取数据 */
      let data = utils.deepClone(componentProperties.get(event.dataTransfer.getData('componentName')))

      /* 查询是否只能存在一个的组件且在第一个 */
      let someOne = this.pageComponents.some((item, index) => {
        return (
          item.component === 'placementarea' &&
          index === 0 &&
          this.onlyOne.includes(data.type)
        )
      })

      if (someOne) {
        this.$Message.warning('固定位置的组件(如: 底部导航、悬浮)不能放在第一个!')
        /* 删除提示组件 */
        this.dragleaves()
        return
      }

      /* 查询是否只能存在一个的组件 */
      let someResult = this.pageComponents.some((item) => {
        return (
          this.onlyOne.includes(item.type) &&
          item.component === event.dataTransfer.getData('componentName')
        )
      })
      if (someResult) {
        this.$Message.warning('当前组件只能添加一个!')
        /* 删除提示组件 */
        this.dragleaves()
        return
      }

      /* 替换 */
      utils.forEach(this.pageComponents, (res, index) => {
        /* 修改选中 */
        if (res.active === true) res.active = false
        /* 替换提示 */
        this.index = index
        if (res.component === 'placementarea')
          this.$set(this.pageComponents, index, data)
      })

      /* 切换组件 */
      this.rightcom = data.style
      /* 丢样式 */
      this.currentproperties = data.setStyle

      console.log(
        data,
        this.rightcom,
        this.currentproperties,
        '----------components data'
      )
    },

    /**
     * 当拖动的元素或文本选择离开有效的放置目标时，会触发此事件
     *
     * @param {Object} event event对象
     */
    dragleaves () {
      /* 删除提示组件 */
      this.pageComponents = this.pageComponents.filter(
        (res) => res.component !== 'placementarea'
      )
    },

    /**
     * 切换组件位置
     *
     * @param {Object} res 组件切换后返回的位置
     */
    componenmanagement (res) {
      this.pageComponents = res
    },

    /**
     * 选择组件
     *
     * @param {Object} res 当前组件对象
     */
    activeComponent (res, index) {
      this.index = index
      /* 切换组件 */
      this.rightcom = res.style
      /* 丢样式 */
      this.currentproperties = res.setStyle

      /* 替换 */
      utils.forEach(this.pageComponents, (res) => {
        /* 修改选中 */
        if (res.active === true) res.active = false
      })

      /* 选中样式 */
      res.active = true
    },

    /**
     * 标题切换
     *
     * @param {Object} res 当前组件对象
     */
    headTop () {
      this.rightcom = 'decorate'

      /* 替换 */
      utils.forEach(this.pageComponents, (res) => {
        /* 修改选中 */
        if (res.active === true) res.active = false
      })
    },

    /* 删除组件 */
    deleteObj (index) {
      this.pageComponents.splice(index, 1)
      if (this.index === index) this.rightcom = 'decorate'
      if (index < this.index) this.index = this.index - 1
    },

    /* 页面刷新 */
    reloads () {
      this.$Modal.confirm({
        title: '提醒',
        content: '<p>重置后您添加或者修改的数据将会失效, 是否继续?</p>',
        okText: '重置',
        onOk: () => {
          this.index = ''//当前选中的index
          this.rightcom = 'decorate' //右侧组件切换
          this.currentproperties = {} //当前属性
          this.pageSetup = {
            // 页面设置属性
            name: '页面标题', //页面名称
            details: '', //页面描述
            isPerson: false, // 是否显示个人中心
            isBack: true, // 是否返回按钮
            titleHeight: 35, // 高度
            bgColor: 'rgba(255, 255, 255, 1)', //背景颜色
            bgImg: '', // 背景图片
          }
          this.pageComponents = [], //页面组件
            this.offsetY = 0 //记录上一次距离父元素高度
          this.pointer = { show: false } //穿透
        }
      })
    },

    // 返回上一步
    Previous () {
      this.$Modal.confirm('返回列表您添加或者修改的数据将会失效, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$router.go(-1)
      }).catch(() => { })
    },

    // 导出json
    exportJSON () {
      // 将json转换成字符串
      const data = JSON.stringify({
        id: this.id,
        name: this.pageSetup.name,
        templateJson: JSON.stringify(this.pageSetup),
        component: JSON.stringify(this.pageComponents),
      })
      const blob = new Blob([data], { type: '' })
      FileSaver.saveAs(blob, `${this.pageSetup.name}.json`)
    },
    // 导入json
    importJSON () {
      const file = document.getElementById('file').files[0]
      const reader = new FileReader()
      reader.readAsText(file)
      let _this = this
      reader.onload = function () {
        // this.result为读取到的json字符串，需转成json对象
        let ImportJSON = JSON.parse(this.result)
        // 检测是否导入成功
        console.log(ImportJSON, '-----------------导入成功')
        // 导入JSON数据
        _this.id = ImportJSON.id
        _this.pageSetup = JSON.parse(ImportJSON.templateJson)
        _this.pageComponents = JSON.parse(ImportJSON.component)
      }
    },
  },
  computed: {
    scale: function () {
      return `scale(${this.scalePercent / 100})`
    }
  },
  watch: {
    /* 监听右侧属性设置切换 */
    rightcom (newval) {
      if (newval === 'decorate') {
        utils.forEach(this.pageComponents, (res) => {
          /* 修改选中 */
          if (res.active === true) res.active = false
        })
        this.currentproperties = this.pageSetup
        return
      }
      if (newval === 'componenmanagement') {
        /* 替换 */
        utils.forEach(this.pageComponents, (res) => {
          /* 修改选中 */
          if (res.active === true) res.active = false
        })
        this.currentproperties = this.pageComponents
      }
      this.toolBarClose = false
    },
  },
  mounted () {
    let _this = this

    this.pageSetup.name = '页面标题'
    this.currentproperties = this.pageSetup
    this.$nextTick(() => {
      let scW = Number.parseInt(_this.$refs.panelContainer.clientWidth / 1920 * 100)
      let scH = Number.parseInt(_this.$refs.panelContainer.clientHeight / 1080 * 100)
      _this.scalePercent = (scW > scH ? scH : scW)

    })
    document.addEventListener("dragover", function (e) {
      mouseXY.x = e.clientX
      mouseXY.y = e.clientY
    }, false)
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/static/iconfont/iconfont.css';
.pointer-events {
  pointer-events: none;
}

.home {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  /* 删除组件 */
  .deles {
    display: none;
    position: absolute;
    min-width: 80px;
    text-align: center;
    line-height: 25px;
    background: #fff;
    height: 25px;
    font-size: 12px;
    left: -4rem;
    top: 50%;
    transform: translateY(-50%);

    .icon-sanjiaoxingzuo {
      position: absolute;
      left: -11px;
      color: #fff;
      font-size: 12px;
      top: 50%;
      transform: translateY(-50%);
    }

    &:hover {
      i {
        display: block;
        position: absolute;
        left: 0;
        font-size: 16px;
        top: 0;
        text-align: center;
        line-height: 25px;
        width: 100%;
        color: #fff;
        height: 100%;
        z-index: 10;
        background: rgba(0, 0, 0, 0.5);
      }
      .icon-sanjiaoxingzuo {
        color: rgba(0, 0, 0, 0.5);
      }
    }

    i {
      display: none;
    }
  }

  /* 按钮集合 */
  .buttons {
    padding: 0.5rem;
    border-bottom: 1px solid #ebedf0;
    display: flex;
    justify-content: flex-end;
    box-sizing: border-box;
    align-items: center;
    /* 下拉 */
    .frop {
      padding-right: 15px;
      .Button.Button--primary.el-dropdown-selfdefine {
        background: #fff;
        color: #000;
        border: 1px solid #dcdee0;
      }
    }
    .Button {
      font-size: 14px;
      padding: 0 16px;
      height: 30px;
      &.Button--primary {
        background: #155bd4;
      }
      &.Button--danger {
        background: red;
      }
    }
  }

  /* 操作主体 */
  .operation {
    width: 100%;
    position: relative;
    flex-grow: 1;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #e9eef3;
    background-image: linear-gradient(
        45deg,
        #f5f5f5 25%,
        transparent 0,
        transparent 75%,
        #f5f5f5 0
      ),
      linear-gradient(
        45deg,
        #f5f5f5 25%,
        transparent 0,
        transparent 75%,
        #f5f5f5 0
      );
    background-size: 20px 20px;
    background-position: 0 0, 10px 10px;

    .sliderConatiner {
      height: 100%;
      width: 15vw;
      // padding: 1rem;
      overflow: hidden;
      background: #fff;
      /* 组件 */
      .sliderassembly {
        width: 100%;
        box-sizing: border-box;
        /* 组件列表 */
        .componList {
          display: inline-flex;
          flex-direction: column;
          justify-content: center;
          width: 80px;
          height: 88px;
          margin-bottom: 8px;
          align-items: center;
          cursor: all-scroll;
          transition: all 0.3s;
          &:hover {
            background: #155bd4;
            border-radius: 2px;
            font-weight: 700;
            i,
            p,
            span {
              color: #fff;
            }
          }
          /* 图标 */
          i {
            font-size: 32px;
            width: 32px;
            height: 32px;
            line-height: 32px;
            color: #b0a8a8;
            margin-top: 4px;
          }
          /* 标题 */
          p {
            font-size: 12px;
            color: #323233;
            margin-top: 4px;
          }
          /* 数量 */
          span {
            color: #7d7e80;
            margin-top: 4px;
            font-size: 10px;
          }
        }
      }
    }
  }

  /* 驾驶舱面板 */
  .panel {
    height: 100%;
    max-height: 100%;
    overflow: hidden;
    border-top: 1px solid #ebedf0;
    position: relative;

    &.full {
      width: 85vw;
      transition: all 0.3s ease-in-out;
    }

    &.part {
      width: 60vw;
      transition: all 0.3s ease-in-out;
    }

    /* 驾驶舱样式  1920 * 1080的比列*/
    .panelAll {
      padding: 1rem 1rem 0 1rem;
      height: 100%;
      overflow: hidden;
      // margin: auto;
      // position: absolute;
      // left: 1rem;
      // right: 1rem;
      // top: 1rem;
      // bottom: 1rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      /* 状态栏 */
      .statusBar {
        width: 100%;
        display: block;
      }

      .panel-container-p {
        width: 100%;
        flex-grow: 1;
        overflow: hidden;

        /* 主体内容 */
        .panel-container {
          // margin: 1rem;
          width: 1920px;
          height: 1080px;
          min-height: 1080px;
          // width: 58vw;
          // height: calc(58vw * 0.5625);
          // min-height: calc(58vw * 0.5625);
          box-sizing: border-box;
          cursor: pointer;
          position: relative;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          overflow: hidden;

          .componentsClass {
            width: 100%;
            height: 100%;
            border: 1px solid #fff;
            &:hover {
              border: 1px dashed #155bd4;
            }
          }
        }
      }

      .toolsContianer {
        // position: absolute;
        // bottom: 1rem;
        padding-top: 0.5rem;
        text-align: center;

        /* 尺寸 */
        .panelSize {
          text-align: center;
          font-size: 0.75rem;
          color: #a2a2a2;
          line-height: 1.5rem;
        }
      }
    }
  }

  /* 右侧工具栏 */
  .decorateAll {
    box-shadow: 0px 0px 5px #ddd;
    border-top: 1px solid #ebedf0;
    position: relative;
    display: flex;
    flex-direction: column;
    right: 0;
    z-index: 999;

    background: #fff;
    &.close {
      width: 0;
      padding: 0;
      transition: all 0.3s ease-in-out;
    }
    &.open {
      transition: all 0.3s ease-in-out;
      width: 25vw;
      padding: 0 0.5rem;
    }

    .toolBar {
      box-shadow: -4px 2px 6px #ddd;
      cursor: pointer;
      position: absolute;
      top: 0;
      bottom: 0;
      left: -1.5rem;
      height: fit-content;
      margin: auto;
      padding: 2rem 1rem 2rem 0.5rem;
      background: #fff;
      border-radius: 0.5rem 0 0 0.5rem;
    }

    .decoratePanel {
      width: 100%;
      flex-grow: 1;
      overflow: hidden;
    }
  }
}
</style>
